import React, {useEffect, useState} from "react";

import {TiWarningOutline} from "react-icons/ti";
import Vector from "../../assets/images/session-exceed-vector.svg";
import {pediaActiveSessions, removePediaActiveSessionById} from "../account/service";
import {useNavigate, useSearchParams} from "react-router-dom";
import DeviceCard from "./DeviceCard";
import DeviceRemovalToast from "./DeviceRemovalToast";
import {errorMessage} from "../../utils/helper";
import {trackDeviceLogoutClicked, trackDeviceLogoutResult} from "../../utils/zymedSessionDiagnostics";


const SessionExceed = () => {

    const [searchParams] = useSearchParams();
    const [b2c] = useState(searchParams.get("b2c"));
    const [allowedCount] = useState(searchParams.get("allowedCount") || 1);
    const [devices, setDevices] = useState<any>([]);
    const navigate = useNavigate();
    const [removed, setRemoved] = useState(false);

    const fetchSessions = async () => {
        if (b2c) {
            const activeResponse: any = await pediaActiveSessions(b2c);
            if (activeResponse !== undefined) {
                const sessions: any[] = activeResponse?.data?.body?.content;
                const deviceType = localStorage.getItem("device_type") + "_" + b2c;
                let countSessions = sessions.filter((session: any) => session.deviceType !== deviceType).length;
                let sessionsToShowcase = sessions.filter((session: any) => session.deviceType !== deviceType);
                if (allowedCount >= countSessions) {
                    setDevices(sessionsToShowcase);
                }
            }
        }
    }

    useEffect(() => {
        fetchSessions();
    }, [b2c]);

    const onLogout = async (device: any) => {
        const id = device?.id;
        console.log("removing device with id" + id);
        trackDeviceLogoutClicked(device, devices?.length || 0);
        const res: any = await removePediaActiveSessionById(id);
        trackDeviceLogoutResult({
            targetSessionId: id,
            outcome: res !== undefined ? "success" : "failed",
            httpStatus: res?.status,
            serverMessage: res?.data?.message,
        });
        if (res !== undefined) {
            setRemoved(true);
            navigate("/");
        } else {
            errorMessage("Could not log out that device. Please try again.");
        }
    }

    return (<>
            <header className="w-full flex justify-center bg-white text-[#4b4ad5] shadow-md">
                <div className="w-full max-w-md flex justify-between items-center px-4 py-3">
                    <h1 className="text-xl font-bold">ZyMedElite</h1>
                    {/* <a href="#" className="text-sm text-blue-500 underline">
                        Trouble Logging in?
                    </a>*/}
                </div>
            </header>

            {/* MAIN CONTENT */}
            <div
                className="h-full pb-32 flex bg-cover bg-center bg-no-repeat flex-col items-center text-white px-4 py-6"
                style={{
                    backgroundColor: '#4534c0',
                    backgroundImage: `url(${Vector})`
                }}
            >
                {/* Alert box */}
                <div
                    className="w-full max-w-md flex items-start gap-2 bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded-xl text-sm mb-6">
                    <TiWarningOutline className="text-yellow-600 h-auto top-0" style={{fontSize: "80px"}}/>
                    <span>
      You’ve reached <strong>maximum limit</strong> of the device for this account. To add a new device, please <strong>logout</strong> from one device or contact support.
    </span>
                </div>

                {/* Device Cards */}
                {devices?.length > 0 &&
                    devices.map((device: any, index: any) => (
                        <DeviceCard key={index} loggedInAt={device?.loggedInAt} deviceId={device?.deviceId}
                                    deviceInfo={device?.deviceInfo} onLogout={()=>onLogout(device)}/>
                    ))}
            </div>
            {removed && <DeviceRemovalToast/> }
        </>
    );
};

export default SessionExceed;